export default {
  'component': {
    'tradeInProcess': {
      '649f8aefats0': 'Délai de commande dépassé',
      '649f8aefc1c0': 'Échec du recyclage',
      '649f8aefc9c0': 'Vendre maintenant',
      'TradeIn': 'Processus de reprise',
      'logistic': 'Télécharger l\'étiquette d\'expédition',
      'start': 'Commencer',
      'success': 'Vous avez bien réceptionné le nouvel appareil',
      'qc': 'Contrôle qualité de l\'ancien appareil',
      'business': 'Nous terminerons l\'inspection de votre ancien appareil sous 3 jours ouvrables',
      'completed': 'Terminé',
      'successfully': 'Félicitations, votre reprise a réussi',
      'orderInfor': 'Informations sur la commande',
      'orderID': 'ID de la commande de reprise',
      'orderNum': 'ID de la commande d\'achat du nouvel appareil',
      'createTime': 'Date de création',
      'brand': 'Marque estimée',
      'model': 'Modèle estimé',
      'price': 'Prix de l\'ancien appareil',
      'bonus': 'Bonus',
      'reclaimFailure': 'Vous n\'avez pas envoyé l\'appareil sous 10 jours après réception, la commande de recyclage a expiré et été annulée. Si vous souhaitez toujours recycler l\'ancien appareil, cliquez sur le bouton ci-dessous pour vérifier le dernier devis.',
      'total': 'Prix total',
      'logisticInfo': 'Informations logistiques',
      'available': 'Aucune information logistique disponible',
      'logisticNum': 'Numéro de suivi',
      'failRey': 'Nous sommes désolés que votre participation au programme de recyclage OnePlus n\'ait pas abouti. Si vous avez d\'autres appareils électroniques à recycler, cliquez sur le bouton ci-dessous pour une estimation rapide !!',
      'userRes': 'L\'utilisateur a déjà refusé l\'offre.',
      'successPrice': 'Le prix suivant est après inspection professionnelle. Si vous l\'acceptez, la reprise se poursuivra. Sinon, l\'appareil vous sera renvoyé sous quelques jours ouvrables.',
      'sure': 'Accepter',
      'Reject': 'Refuser',
      'congratulation': 'Félicitations QC : aucune différence.',
      'finPirce': 'Prix final',
      'copySuccess': 'Copie réussie',
      'copyfail': 'Échec de la copie',
      'sureSuccess': 'Confirmer la transaction réussie',
      'submitError': 'Échec de la soumission',
      'detectionResult': 'Résultat de la détection',
      'Collected': 'Collecté',
      'inTransit': 'En transit/Expédition',
      '656g0lj3sav6': 'Processus de recyclage',
      '656g0lj3cd5a': 'Remplissez correctement vos informations personnelles et passez la commande avec succès',
      '656g0lj3dr9a': 'L\'inspection de votre téléphone sera terminée sous 48 heures après son arrivée dans notre centre',
      '656g0lj3epal': 'Une fois l\'inspection terminée, nous vous contacterons par email avec l\'offre finale',
      '656g0lj3pda2': 'Votre estimation',
      '656g0lj3ed3d': 'Contrôle qualité professionnel',
      '656g0lj3esf3': 'Copier',
      'expertDiscount': 'code promotionnel',
      'invalidCode': 'Code invalide',
      'toastTip': 'Cochez pour accepter la Politique de confidentialité et les Conditions.',
      '649f8aef26sf': 'Processus de reprise',
      'checkTitle': 'Informazioni sull\'ordine',
      'understand': 'I understand',
      '656g0lj3sf6e': 'Les bonus promotionnels sont offerts et gérés par les marques partenaires.Ils seront versés séparément et ne font pas partie de l\'évaluation de l\'ancien appareil.'
    },
    'btnDialog': {
      '64a9shqq2ks0': 'Refuser de recycler',
      '64a9shqq3k00': 'Vous confirmez que vous refusez de recycler',
      '64a9shqq3r00': 'Annulation réussie',
      '64a9shqq3ws0': 'Échec de l\'annulation',
      'sureCancel': 'Confirmer l\'annulation'
    }
  },

  'home': {
    'whoAreWe': {
      '646u995ltgw0': 'Qui',
      '646u995lv9g0': 'sommes-nous?',
      '646u9d5lv9g0': 'Danghuan est une société dont l\'activité principale est axée sur le recyclage, la valorisation et la vente de produits numériques 3C tels que les mobiles, tablettes, ordinateurs portables et montres. Notre société s\'engage à accélérer l\'efficacité du recyclage des produits électroniques et à promouvoir le développement sain du marché de l\'occasion. Actuellement, nous avons établi des partenariats stratégiques officiels avec OPPO, Vivo, OnePlus, Realme et d\'autres. Nos activités à l\'étranger se sont étendues à l\'Inde, la Thaïlande, le Vietnam, le Cambodge et maintenant l\'Europe.',
      '646u995dv9g0': 'Notre présence mondiale nous a positionnés comme un partenaire stratégique pour les opérateurs mobiles, les fabricants et les grossistes avec une portée continentale et transcontinentale.',
      '646u99slv9g0': 'Nous collaborons avec des fabricants leaders et maintenons un inventaire diversifié qui comprend des appareils d\'entrée, milieu et haut de gamme. Cela nous permet de fournir des solutions personnalisées et des prix compétitifs pour répondre aux besoins de nos clients.'
    },
    'business': {
      '646v04syvpk0': 'Êtes-vous intéressé par l\'achat de notre stock?',
      '646v04syxs80': 'Chez Danghuan, nous proposons une sélection complète de téléphones portables, tablettes et montres connectées, disponibles dans différents niveaux de classement pour répondre à divers besoins commerciaux.',
      '646v04syy6g0': 'Contactez notre responsable des ventes et achats :',
      '646v04syya80': 'Je veux acheter',
      '646v04syydg0': 'Entrez votre nom',
      '646v04syyh40': 'Entrez votre téléphone',
      '646v04syyyw0': 'Entrez votre email',
      '646v0gsyz1s0': 'Pays:',
      '646v04syz1s0': 'Veuillez choisir une option',
      '646v04syz4o0': 'J\'ai lu et j\'accepte la',
      '646v04syzkc0': 'Politique de confidentialité',
      '646v04syzok0': 'Contactez-nous',
      '646v04syzvo0': 'Veuillez entrer votre numéro de téléphone',
      '646v04syzys0': 'Veuillez entrer votre email',
      '646v04sz01o0': 'Veuillez entrer un email valide',
      '646v04sz04g0': 'Veuillez entrer votre nom',
      '646v04sz0740': 'Veuillez cocher la case pour accepter la politique de confidentialité',
      '646v04sz0a00': 'Soumission réussie',
      '646v04sz0cw0': 'Échec de la soumission',
      'title1': 'Classement transparent des mobiles',
      'text1-1': 'Pour soutenir vos décisions d\'achat, nous vous encourageons à consulter notre document de classement détaillé. Il décrit les normes esthétiques et fonctionnelles de chaque grade, vous permettant de faire des choix éclairés qui correspondent à vos attentes.',
      'title2': 'Support client exceptionnel',
      'text2-1': 'Nous reconnaissons les besoins uniques de chaque client, c\'est pourquoi notre équipe de professionnels de vente multilingues se consacre à fournir une assistance personnalisée et experte.',
      'title3': 'Engagement envers la technologie durable',
      'text3-1': 'Nous nous engageons à promouvoir l\'accès mondial à des solutions technologiques durables, en veillant à ce que nos processus créent de la valeur pour toutes les parties prenantes concernées.',
      'text3-2': 'Pour toute demande supplémentaire ou pour organiser un essai, veuillez nous contacter. Notre équipe est prête à vous aider avec professionnalisme et attention.'
    }
  },
  'components': {
    'section2': {
      '646tj9dnkk00': 'Obtenez un paiement rapide en seulement 4 étapes',
      's1': 'Première étape',
      's1t': 'Emballez votre appareil pour qu\'il arrive dans le même état que lorsqu\'il a été envoyé.',
      's2': 'Deuxième étape',
      's2t': 'Déposez votre colis à notre point de dépôt.',
      's3': 'Troisième étape',
      's3t': 'Faisons vérifier votre appareil et obtenez un devis.',
      's4': 'Quatrième étape',
      's4t': 'Obtenez un paiement rapide.'
    },
    'section3': {
      '646tmse2fbo0': 'Smartphones',
      '646tmse2mv00': 'Restez à l\'écoute',
      'section3-text2': 'Tablettes',
      'section3-text4': 'Montres',
      'section3-text5': 'Autres',
      'title': 'Évaluation rapide',
      't1': 'Sélectionnez le type et commencez l\'évaluation, obtenez un devis équitable.',
      't2': 'Étapes simples, profitez de notre service de recyclage rapide !'
    },
    'section6': {
      '646txzpazuc0': 'À propos de Danghuan',
      '666txzpazuc0': 'Une entreprise spécialisée dans le recyclage et la réutilisation des smartphones, tablettes et autres appareils numériques, dédiée à fournir un processus de service simple, sûr et efficace, permettant à chaque client de réaliser facilement le recyclage d\'appareils usagés.',
      '646txzpb0rk0': 'Détails',
      '646txzpb0xc0': 'Fournir le recyclage de 12 marques'
    },
    'section7': {
      '646ns2k5f7k0': 'Notre service est toujours disponible',
      '646ns2k5gmw0': 'Service client : du lundi au vendredi de 9h00 à 18h00 CET (UTC+1:00) Madrid, Espagne',
      '646ns2k5gs40': 'Entrez votre nom',
      '646ns2k5gx40': 'Entrez votre téléphone',
      '646ns2k5img0': 'Entrez votre email',
      '646ns2k5isw0': 'Écrivez-nous un message avant que nous ne vous contactions',
      '646ns2k5iws0': 'Contactez-nous',
      '646ns2k5j140': 'Veuillez entrer votre numéro de téléphone',
      '646ns2k5j4g0': 'Veuillez entrer votre email',
      '646ds2k5j4g0': 'Email',
      '646ns2k5j6c0': 'Veuillez entrer un email valide',
      '646ns2k5j8g0': 'Contactez-nous',
      '646ns2k5jak0': 'C.I.F :',
      '646ns2k5jck0': 'Adresse',
      '646ns2s5jck0': 'Calle Tomás Bretón, 46, Planta 1, Oficina 5, 28045 Madrid, España',
      '646ns2k5jgc0': 'Veuillez entrer votre nom',
      '646ns2k5ji40': 'Veuillez cocher la case pour accepter la politique de confidentialité',
      '646ns2k5jk00': 'Soumission réussie',
      '646ns2k5jm80': 'Échec de la soumission',
      '646ny1rgz3c0': 'J\'ai lu et j\'accepte la ',
      '646ny1rh2k40': 'Politique de confidentialité'
    },
    'successMain': {
      '647qmd42l1s0': 'Commande reçue avec succès !',
      '647qmd42mss0': 'Veuillez prêter attention à l\'email d\'instructions d\'expédition envoyé par noreply@Danghuan.eu. Si vous ne l\'avez pas reçu, veuillez vérifier votre dossier SPAM ou contacter notre service client à support@danghuan.es',
      '647qmd42mz80': 'Notre offre',
      '647qmd42yeo0': 'Conseils avant l\'expédition',
      'orderTime': 'Heure de la commande',
      'text1': 'Livraison gratuite',
      'text2': 'Veuillez prêter attention au document d\'expédition envoyé à votre e-mail.',
      'text3': 'Sauvegarde des données',
      'text4': 'Pour protéger vos données, veuillez les sauvegarder et supprimer toutes les données ou réinitialiser l\'appareil.',
      'text5': 'Charger',
      'text6': 'Veuillez charger votre téléphone à 1 % avant l\'expédition afin d\'accélérer l\'inspection.',
      'downloadDec': 'Veuillez télécharger la Déclaration d\'intégrité.'
    },
    'tradeInProcess': {
      '649f8aefats0': 'Délai de commande dépassé',
      '649f8aefc1c0': 'Échec du recyclage',
      '649f8aefc9c0': 'Vendre maintenant',
      'TradeIn': 'Processus de reprise',
      'logistic': 'Télécharger l\'étiquette d\'expédition',
      'start': 'Commencer',
      'success': 'Vous avez bien réceptionné le nouvel appareil',
      'qc': 'Contrôle qualité de l\'ancien appareil',
      'business': 'Nous terminerons l\'inspection de votre ancien appareil sous 3 jours ouvrables',
      'completed': 'Terminé',
      'successfully': 'Félicitations, votre reprise a réussi',
      'orderInfor': 'Informations sur la commande',
      'orderID': 'Numéro de commande de recyclage',
      'orderNum': 'ID de la commande d\'achat du nouvel appareil',
      'createTime': 'Date de création',
      'brand': 'Marque estimée',
      'model': 'Modèle',
      'price': 'Prix de l\'ancien appareil',
      'bonus': 'Bonus',
      'total': 'Prix total',
      'logisticInfo': 'Informations logistiques',
      'available': 'Aucune information logistique disponible',
      'logisticNum': 'Numéro de suivi',
      'failRey': 'Nous sommes désolés que votre participation au programme de recyclage OnePlus n\'ait pas abouti. Si vous avez d\'autres appareils électroniques à recycler, cliquez sur le bouton ci-dessous pour une estimation rapide !!',
      'userRes': 'L\'utilisateur a déjà refusé l\'offre.',
      'successPrice': 'Le prix suivant est après inspection professionnelle. Si vous l\'acceptez, la reprise se poursuivra. Sinon, l\'appareil vous sera renvoyé sous quelques jours ouvrables.',
      'sure': 'Accepter',
      'Reject': 'Refuser',
      'congratulation': 'Félicitations QC : aucune différence.',
      'finPirce': 'Prix final',
      'copySuccess': 'Copie réussie',
      'copyfail': 'Échec de la copie',
      'sureSuccess': 'Confirmer la transaction réussie',
      'submitError': 'Échec de la soumission',
      'detectionResult': 'Résultat de la détection',
      'Collected': 'Collecté',
      'inTransit': 'En transit/Expédition',
      'understand': 'Je comprends',
      '656g0lj3sf6e': 'Les bonus promotionnels sont offerts et gérés par les marques partenaires.Ils seront versés séparément et ne font pas partie de l\'évaluation de l\'ancien appareil.'
    },
    'btnDialog': {
      '64a9shqq2ks0': 'Refuser de recycler',
      '64a9shqq3k00': 'Vous confirmez que vous refusez de recycler',
      '64a9shqq3r00': 'Annulation réussie',
      '64a9shqq3ws0': 'Échec de l\'annulation',
      'sureCancel': 'Confirmer l\'annulation'
    }
  },
  'shippingLable': {
    'shippingLable': {
      'firstStep': 'Informations personnelles',
      '649fhwp9zbo0': 'Téléchargez une photo claire de votre colis',
      '649fhwpa1900': 'Télécharger l\'étiquette d\'expédition',
      '649fhwpa1l00': 'Télécharger l\'étiquette d\'expédition',
      '649fhwpa1tc0': 'Livraison complète',
      '649fhwpa2100': 'Exemple de placement de l\'étiquette d\'expédition',
      '649fhwpa2880': 'Étiquette d\'expédition',
      '649fhwpa2h80': 'Remarque',
      '649fhwpa2qk0': 'Emballez le téléphone avec au moins 6 cm de matériau de rembourrage (papier bulle, papier kraft, etc.) et placez-le dans une boîte en carton solide.',
      '649fhwpa2xs0': 'Comblez les espaces vides avec un rembourrage protecteur pour éviter les dommages.',
      '649fhwpa3fk0': 'Assurez-vous d\'imprimer clairement l\'étiquette d\'expédition et de la fixer solidement pour éviter qu\'elle ne se détache pendant le transport.',
      '649fhwpa3v40': 'Veuillez expédier l\'ancien téléphone dès que possible après l\'emballage. Si l\'envoi n\'est pas effectué dans le délai spécifié (10 jours), la commande sera annulée.',
      '649fhwpa42s0': 'Points de dépôt',
      '649fhwpa4as0': 'Télécharger l\'étiquette',
      '649fhwpa4jo0': 'Télécharger',
      '649fhwpa4ok0': 'Accueil',
      '649fhwpa4to0': 'Soumis avec succès',
      '649fhwpa4yk0': 'Félicitations, téléchargement réussi !',
      '649fhwpasf3s': 'Attention',
      '649fhwpaa6f3': 'Veuillez imprimer et signer la Déclaration d\'Intégrité, puis prendre une photo avec le colis de l\'ancien appareil et la télécharger.'
    }
  },
  'bottom': {
    'index': {
      '646d51qugz40': 'Réseaux sociaux',
      '646d71qugz40': 'Paiement facile',
      '646u51qugz40': 'Logistique',
      '646u5dqui780': 'Politique de confidentialité',
      '646uddqui780': 'Conditions générales',
      '646u51qui780': 'FAQ'
    }
  },
  'head': {
    'index': {
      '646nt7hwh0c0': 'À propos de Danghuan',
      '646ntjwmn580': 'Entreprise',
      '646nt7hwils0': 'Contactez-nous',
      '646nt7hwipg0': 'Acheter',
      '646nt7hwis00': 'Vendre'
    }
  },
  'PCModelList': {
    'index': {
      '646wfv5g0ro0': 'Estimation gratuite'
    }
  },
  'PCSearch': {
    'index': {
      '646wgb1ni8k0': 'Entrez le modèle que vous souhaitez vendre',
      '646wgb1nj8o0': 'Terme de recherche',
      '646wgb1nji80': 'J\'ai déclenché la recherche vers le haut',
      'empty': 'Désolé, le modèle n\'existe pas',
      'confirm': 'Confirmer',
      'cancle': 'Annuler',
      'dialogText': 'Êtes-vous sûr de vouloir supprimer tous les historiques \n d\'enregistrements?'
    }
  },
  'PCProduct': {
    'empty': 'Désolé, le modèle n\'existe pas'
  },
  'PCBrandTab': {
    'index': 'Marque'
  },
  'PCCategoryTab': {
    'index': 'Catégorie'
  },
  'PCOrderStep': {
    'index': {
      '646xagqwff40': 'Commander en ligne',
      '646xagqwkuw0': 'Livraison gratuite',
      '646xagqwmao0': 'Test',
      '646xagqwmlc0': 'Paiement rapide'
    }
  },
  'PCBreadNav': {
    'index': {
      '646xgup6ugg0': 'Accueil'
    }
  },
  'router': {
    'selectModel': 'Modèles',
    'selectProperty': 'Problèmes de l\'appareil',
    'price': 'Prix estimé',
    'priceOrder': 'Passer une commande',
    'orderSuccess': 'Commande réussie'
  },
  'PCDeviceInfo': {
    'index': {
      '646ymq6orm00': 'Resélectionner le modèle',
      '646ymq6ot0k0': 'Rappel',
      '646ymq6pd100': 'Avant l\'expédition, veuillez vous assurer de vous déconnecter du compte cloud',
      '646ymq6pekw0': '/verrouillage d\'écran/Apple ID sur l\'ancien appareil.'
    }
  },
  'PCModelInfo': {
    'index': {
      '646yn085ljk0': 'Sélectionnez l\'état de l\'appareil',
      '647h1f4yr6c0': 'Prix estimé',
      '647h1f4yso80': 'Bonus estimé',
      'text1': 'Livraison gratuite',
      'text2': 'Ofrecemos un servicio de logística y envío gratuito',
      'text3': 'Paiement immédiat',
      'text4': 'Nous effectuerons le paiement dans un délai de 1 à 2 jours ouvrables une fois que nous aurons reçu votre appareil usagé.',
      '64tve23zt0g0': 'Livraison gratuite et pack de vente',
      '64tve23zup00': 'Effacement sécurisé des données',
      '64tve23zuy40': 'Pas satisfait ? Retours gratuits',
      '64tve23zv7g0': 'Le paiement sera organisé dans un délai de 1 à 2 jours ouvrables après réception de l\'appareil',
      '64tve23zvbg0': 'Choisissez votre méthode de livraison',
      '64tve23zvf80': 'Vous avez 10 jours pour livrer votre téléphone.',
      '64tve23zvjc0': 'Obtenez une étiquette d\'expédition gratuite et envoyez votre téléphone',
      '64tve23zvms0': 'Obtenez une étiquette d\'expédition sur votre email',
      '64tve23zvqg0': 'Remarque:',
      '64tve23zvyo0': 'En raison des restrictions d\'expédition liées aux batteries au lithium, n\'envoyez pas le téléphone si vous avez une raison de suspecter que la batterie pourrait être défectueuse ou endommagée.',
      '64tve23zwak0': 'Nous ne sommes pas en mesure de retourner les accessoires ou l\'emballage envoyés avec l\'appareil.',
      '64tve23zwgs0': 'Prochaines étapes pour vendre votre téléphone',
      '64tve23zwm80': 'Remplissez vos coordonnées',
      '64tve23zwt00': 'Préparez votre téléphone pour l\'expédition',
      '64tve23zwwk0': 'Votre appareil sera vérifié à son arrivée. Si les informations que vous avez fournies sont inexactes, nous enverrons une nouvelle offre. Vous pouvez accepter la nouvelle offre ou récupérer votre téléphone gratuitement.'
    }
  },
  'PCPropertyList': {
    'index': {
      '646ynp3udds0': 'Canal d\'achat',
      '646ynp3ueas0': 'Nécessite une activation, ne peut pas passer d\'appels normaux',
      '646ynp3uehw0': 'Entrez le numéro IMEI',
      '646ynp3uem40': 'Composez *#06# sur le clavier pour vérifier l\'IMEI du téléphone'
    }
  },
  'PCButton': {
    'index': {
      '646zhxujd5g0': 'Voir l\'offre'
    }
  },
  'PCBottomButton': {
    'index': {
      '647hqss75ac0': 'Rappel : Le prix des téléphones portables et des produits électroniques peut baisser jusqu\'à 6 %, nous vous recommandons donc d\'expédier votre colis dès que possible.',
      '647hqss760c0': 'J\'ai lu et j\'accepte la',
      '647hqss764w0': 'Politique de confidentialité',
      '647hqss76ac0': 'Conditions générales',
      '647hqss76dg0': 'Soumettre',
      '647hqss76gw0': 'Prix total (Valeur de l\'appareil utilisé)',
      'text1': 'Total',
      'text2': 'Prix estimé',
      'text3': 'Bonus estimé',
      'dialogTitle': 'Avis',
      'dialogText': 'Cliquez sur le bouton CONFIRMER et vérifiez votre e-mail pour passer à l\'étape suivante',
      'dialogBtn': 'CONFIRMER'
    }
  },
  'PCUserInfo': {
    'index': {
      '647kboa03ks0': 'Informations de commande',
      '647kboa06ys0': 'Nom',
      '647kboa0d6v8': 'Country Code',
      '647kboa078s0': 'Téléphone',
      '647kboa07d00': 'Adresse',
      '647kboa07jk0': 'Pays',
      '647kboa07p80': 'Veuillez sélectionner',
      '647kboa08b40': 'Code postal',
      '647kboa08h00': 'Ville',
      '647kboa08zc0': 'Adresse',
      '647kboa09440': 'Informations bancaires',
      '647kboa096w0': 'Vérification de l\'email',
      '647kboa09ao0': 'Email',
      '647kboa09dk0': 'Code de vérification',
      '647kboa09u40': 'Entrer',
      '647kboa09z80': 'Envoyer',
      '647kboa0ak00': 'Erreur de format d\'email',
      '647kboa0aog0': 'Envoyé avec succès',
      'send': 'Envoyé',
      'submit': 'Soumettre',
      'error': 'Erreur de code de vérification',
      '64jjt96fg400': 'Veuillez entrer le code de vérification',
      '64jjt96fki00': 'Veuillez obtenir le code de vérification',
      'idNumber': 'Numéro de carte d\'identité / Numéro d\'identité',
      'declaration': 'Déclaration d\'intégrité',
      'download': 'télécharger',
      '647kboa0idc0': 'N° d\'identité personnelle',
      '647kboa0idc1': '(le numéro d\'identité officiel délivré par votre pays, utilisé pour l\'identification dans les procédures juridiques, fiscales ou administratives. Il peut s\'agir de votre DNI, NIE, Codice Fiscale, Personalausweisnummer, CNP ou d\'un autre document national équivalent, selon votre pays de résidence.)',
      '647kboa0idc2': '(le numéro d\'identité officiel délivré par votre pays, utilisé pour l\'identification dans les procédures juridiques, fiscales ou administratives. Il peut s\'agir de votre DNI, NIE, Codice Fiscale, Personalausweisnummer, CNP ou d\'un autre document national équivalent, selon votre pays de résidence.)',
      'idError': 'Numéro d\'identité invalide',
      'ibanTip': 'Utilisé pour recevoir le paiement de l\'ancien appareil.',
      'addreddPlaceholder': 'Este campo admite hasta 105 caracteres'
    }
  },
  'successOrder': {
    'successOrder': {
      '647s39cv77s0': 'Page d\'accueil',
      'notRecyclable': 'Ce type d\'appareil n\'est pas recyclable',
      'IKnow': 'Je vois',
      'tips': 'Conseils'
    }
  },

  'blog': {
    'blogList': {
      '64wgr171lsk0': 'Vues',
      '64wgr171nq40': 'Aucun contenu associé disponible.',
      '64wgr171av65': 'Date'
    },
    'blogDetail': {
      '64wgr9y5r7s0': 'Vues',
      '64wgr171wdx9': 'Détails'
    }
  },

  'cookieNotice': {
    'title': 'Avis sur les cookies',
    'description': 'Nous utilisons des cookies pour améliorer votre expérience de navigation. En continuant à utiliser ce site web, vous acceptez notre',
    'cookiePolicy': 'Politique relative aux cookies',
    'acceptAll': 'Accepter tous les cookies',
    'acceptNecessary': 'Accepter uniquement les cookies nécessaires',
    'customize': {
      'title': 'Veuillez sélectionner les types de cookies que vous souhaitez accepter :',
      'necessary': {
        'label': 'Cookies nécessaires',
        'description': 'Ces cookies sont essentiels au fonctionnement du site web et ne peuvent pas être désactivés.'
      },
      'analytics': {
        'label': 'Cookies d\'analyse',
        'description': 'Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site web.'
      },
      'marketing': {
        'label': 'Cookies marketing',
        'description': 'Ces cookies suivent l\'activité des utilisateurs sur les sites web pour diffuser des publicités pertinentes.'
      }
    },
    'save': 'Enregistrer les paramètres',
    'cancel': 'Annuler'
  }

}